import React, { Component } from 'react'
import Included from '../Included'
class Media extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
    <section><a className="anchor" id="mediaobjects"></a>
    <h2>Media Objects</h2>
    { this.props.staticVersion === false ? (
      <Included
        onClick={() => this.props.onIncludeClick()}
        included={this.props.included}/>
    ) : ( '' ) }
    <br/>
    <p>Media objects are useful components for displaying an item, usually an image, alongside some content, usually text. You could put lists, grids, or even other media objects inside. Ensure your images follow the 16:9 aspect ratios</p>
    <p>Helper classes exist to aid how the images and text display. These limit the images to a certain percentage.</p>
      <pre><code className="language-css">{`.max-width-10
.max-width-20
.max-width-30
.max-width-40
.max-width-50
.max-width-60
.max-width-70
.max-width-80
.max-width-90
.max-width-100`}</code></pre>
    <br/>
      <select className="size-select">
        <option value="">Select a resolution</option>
        <option value="482">480px (xs)</option>
        <option value="770">768px (sm)</option>
        <option value="994">992px (md)</option>
        <option value="1202">1200px (lg)</option>
      </select>
      <br/><br/>
      <div className="iframe-container" style={{"height":"500px"}}>
        <iframe seamless srcDoc={`
<html>
  <head>
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
  </head>
  <body>
    <div class="media push--bottom">
        <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>
        <div class="media__body"><h3 class="flush"><a href="javascript:;">CME Group to Host Grain Expert Panel Following USDA's March 9 Crop Production and WASDE reports</a></h3>Live expert webcast to discuss the USDA reports and their impact on grain futures markets.</div>
    </div>
    <div class="media media--rev push--bottom">
        <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>
        <div class="media__body"><h3 class="flush"><a href="javascript:;">'Brexit' Can Cause Event Risk for Euro, Pound</a></h3>Watch CME Group Chief Economist Blu Putnam on Futures Institute discuss how the 'Brexit' vote could cause event risk for the British pound, euro.</div>
    </div>
    <div class="media push--bottom">
        <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>
        <div class="media__body"><h3 class="flush"><a href="javascript:;">Will Weakening El Nino Morph Into La Nina?</a></h3>Watch CME Group Chief Economist Blu Putnam on Futures Institute discuss how agriculture markets will see greater volatility if El Nino turns into La Nina.</div>
    </div>
  </body>
</html>`}></iframe>
    </div>

    <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<div class="media push--bottom">
    <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>
    <div class="media__body"><h3 class="flush"><a href="#">CME Group to Host Grain Expert Panel Following USDA's March 9 Crop Production and WASDE reports</a></h3>Live expert webcast to discuss the USDA reports and their impact on grain futures markets.</div>
</div>
<div class="media media--rev push--bottom">
    <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>
    <div class="media__body"><h3 class="flush"><a href="#">'Brexit' Can Cause Event Risk for Euro, Pound</a></h3>Watch CME Group Chief Economist Blu Putnam on Futures Institute discuss how the 'Brexit' vote could cause event risk for the British pound, euro.</div>
</div>
<div class="media push--bottom">
    <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>
    <div class="media__body"><h3 class="flush"><a href="#">Will Weakening El Nino Morph Into La Nina?</a></h3>Watch CME Group Chief Economist Blu Putnam on Futures Institute discuss how agriculture markets will see greater volatility if El Nino turns into La Nina.</div>
</div>`}</code></pre>
    <br/>
    <hr/>
      <select className="size-select">
        <option value="">Select a resolution</option>
        <option value="482">480px (xs)</option>
        <option value="770">768px (sm)</option>
        <option value="994">992px (md)</option>
        <option value="1202">1200px (lg)</option>
      </select>
      <br/><br/>
      <div className="iframe-container" style={{"height":"500px"}}>
        <iframe seamless srcDoc={`
<html>
  <head>
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
  </head>
  <body>
    <div class="grid">
      <div class="grid__col-xs-12 grid__col-md-6">
        <div class="media">
            <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>
            <div class="media__body"><h3 class="flush"><a href="javascript:;">Indicative Opening Price Overview</a></h3>Watch an overview of Indicative Opening Price, including a definition of IOP and a demonstration of IOP scenarios.</div>
        </div>
      </div>
      <div class="grid__col-xs-12 grid__col-md-6">
        <div class="media">
            <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>
            <div class="media__body"><h3 class="flush"><a href="javascript:;">OTC Credit Default Swaps Overview</a></h3>Get an overview of OTC Credit Default Swaps at CME Group, including our credit offering of CDX and iTraxx index.</div>
        </div>
      </div>
      <div class="grid__col-xs-12 grid__col-md-6">
        <div class="media">
            <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>
            <div class="media__body"><h3 class="flush"><a href="javascript:;">NYMEX Energy Options Update</a></h3>Watch Jeff White, Senior Director of Energy Products at CME Group, present a brief update on NYMEX Energy Options trading.</div>
        </div>
      </div>
      <div class="grid__col-xs-12 grid__col-md-6">
        <div class="media">
            <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>
            <div class="media__body"><h3 class="flush"><a href="javascript:;">Corn, Soy and Wheat Volatility Set to Spike?</a></h3>Five factors, including the course of the U.S. dollar, that could change the low-volatility environment in grain markets lulled by ample supplies.</div>
        </div>
      </div>
    </div>
  </body>
</html>`}></iframe>
    </div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<div class="grid">
<div class="grid__col-xs-12 grid__col-md-6">
  <div class="media">
      <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>
      <div class="media__body"><h3 class="flush"><a href="#">Indicative Opening Price Overview</a></h3>Watch an overview of Indicative Opening Price, including a definition of IOP and a demonstration of IOP scenarios.</div>
  </div>
</div>
<div class="grid__col-xs-12 grid__col-md-6">
  <div class="media">
      <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>
      <div class="media__body"><h3 class="flush"><a href="#">OTC Credit Default Swaps Overview</a></h3>Get an overview of OTC Credit Default Swaps at CME Group, including our credit offering of CDX and iTraxx index.</div>
  </div>
</div>
<div class="grid__col-xs-12 grid__col-md-6">
  <div class="media">
      <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>
      <div class="media__body"><h3 class="flush"><a href="#">NYMEX Energy Options Update</a></h3>Watch Jeff White, Senior Director of Energy Products at CME Group, present a brief update on NYMEX Energy Options trading.</div>
  </div>
</div>
<div class="grid__col-xs-12 grid__col-md-6">
  <div class="media">
      <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>
      <div class="media__body"><h3 class="flush"><a href="#">Corn, Soy and Wheat Volatility Set to Spike?</a></h3>Five factors, including the course of the U.S. dollar, that could change the low-volatility environment in grain markets lulled by ample supplies.</div>
  </div>
</div>
</div>`}</code></pre>

<br/>
<hr/>
  <select className="size-select">
    <option value="">Select a resolution</option>
    <option value="482">480px (xs)</option>
    <option value="770">768px (sm)</option>
    <option value="994">992px (md)</option>
    <option value="1202">1200px (lg)</option>
  </select>
  <br/><br/>
  <div className="iframe-container" style={{"height":"500px"}}>
    <iframe seamless srcDoc={`
  <html>
  <head>
  <link rel="stylesheet" type="text/css" href="css/commonUI.css">
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
  </head>
  <body>
    <div class="grid">
      <div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">
        <div class="media media--stacked">
            <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>
            <div class="media__body">
              <h3 class="push-half--top"><a href="javascript:;">Market Regulation Home</a></h3>
              Read an overview of the Market Regulation department.
            </div>
        </div>
      </div>
      <div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">
        <div class="media media--stacked">
            <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>
            <div class="media__body">
              <h3 class="push-half--top"><a href="javascript:;">Regulatory Outreach</a></h3>
              Learn about our Regulatory Outreach program for information and resources to meet your compliance needs.
            </div>
        </div>
      </div>
      <div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">
        <div class="media media--stacked">
            <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>
            <div class="media__body">
              <h3 class="push-half--top"><a href="javascript:;">Disciplinary Actions</a></h3>
              View a full listing of the latest Disciplinary Actions.
            </div>
        </div>
      </div>
      <div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">
        <div class="media media--stacked">
            <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>
            <div class="media__body">
              <h3 class="push-half--top"><a href="javascript:;">Rule Filings</a></h3>
              View the latest rule amendments, as well as an archive of amendments.
            </div>
        </div>
      </div>
    </div>
  </body>
</html>`}></iframe>
    </div>
    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<div class="grid">
<div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">
  <div class="media media--stacked">
      <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>
      <div class="media__body">
        <h3 class="push-half--top"><a href="#">Market Regulation Home</a></h3>
        Read an overview of the Market Regulation department.
      </div>
  </div>
</div>
<div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">
  <div class="media media--stacked">
      <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>
      <div class="media__body">
        <h3 class="push-half--top"><a href="#">Regulatory Outreach</a></h3>
        Learn about our Regulatory Outreach program for information and resources to meet your compliance needs.
      </div>
  </div>
</div>
<div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">
  <div class="media media--stacked">
      <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>
      <div class="media__body">
        <h3 class="push-half--top"><a href="#">Disciplinary Actions</a></h3>
        View a full listing of the latest Disciplinary Actions.
      </div>
  </div>
</div>
<div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">
  <div class="media media--stacked">
      <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>
      <div class="media__body">
        <h3 class="push-half--top"><a href="#">Rule Filings</a></h3>
        View the latest rule amendments, as well as an archive of amendments.
      </div>
  </div>
</div>
</div>`}</code></pre>

    <br/>
    <hr/>
    </section>
  )
}
}

export default Media



// WEBPACK FOOTER //
// ./styleguide/components/sections/Media.js